import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ProductSectorDetail } from 'api'
import { EnvironmentTitle, HeroPanel, DetailTilesContainer, BannerStatusTile, BannerTilesGroup } from 'view/shared/heroPanel'
import { WindowActions } from 'epics/windowEpic'
import { Locale, Translation } from 'locale'
import { productSectorDetailsSelector } from 'selectors/productSelectors'

interface SectorHeroPanelProps {
  productSectorList: ProductSectorDetail[]
  onTearout: () => void
}

const mapStateToProps = createStructuredSelector({
  productSectorList: productSectorDetailsSelector
})

const mapDispatchToProps = {
  onTearout: () => WindowActions.tearoutGrid('/quote/tearout/admin/sectors')
}

const SectorHeroPanelComponent: React.FunctionComponent<SectorHeroPanelProps> = props => {
  const { productSectorList, onTearout } = props

  return (
    <HeroPanel onTearout={onTearout}>
      <DetailTilesContainer>
        <EnvironmentTitle data-test-id={'SectorHeroPanel-EnvironmentTitle'}>
          {Locale.translate(Translation.TC_HERO_SECTORS)}
        </EnvironmentTitle>
        <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_SUMMARY)}>
          <BannerStatusTile title={Locale.translate(Translation.TC_TOTAL)} label={productSectorList.length} />
        </BannerTilesGroup>
      </DetailTilesContainer>
    </HeroPanel>
  )
}

export const SectorHeroPanel = connect(mapStateToProps, mapDispatchToProps)(SectorHeroPanelComponent)
